var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1501 6.125C39.7251 6.125 41.3001 6.125 42.6126 6.3875C43.1376 12.425 43.1376 24.5 36.0501 32.9C30.8001 39.4625 21.8751 42.875 9.80012 42.875H6.38762C5.86262 30.8 8.22512 21.35 13.7376 15.3125C20.3001 7.7 30.8001 6.125 38.1501 6.125ZM38.1501 0.875C23.7126 0.875 -2.79988 6.3875 1.40012 47.6C4.28762 47.8625 7.17512 48.125 9.80012 48.125C56.7876 48.125 47.3376 1.6625 47.3376 1.6625C47.3376 1.6625 43.6626 0.875 38.1501 0.875ZM37.6251 11.375C11.3751 11.375 11.3751 37.625 11.3751 37.625C21.8751 16.625 37.6251 11.375 37.6251 11.375Z",
    fill: "#C08552"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeds);
export default __webpack_public_path__ + "static/media/seeds.8f3cc2db60bea0b8eddb63683b358a35.svg";
export { ForwardRef as ReactComponent };